<div class="chart-bar">
  <p class="chart-bar__info">
    <mfp-amount-currency>
      <span amount>{{ amount | configCurrency }}</span>
      <sup currency>{{ currency }}</sup>
    </mfp-amount-currency>
  </p>
  <div
    class="chart-bar__line"
    [ngClass]="style === 'dark' ? 'chart-bar--dark' : 'chart-bar--light'"
    [style.height.px]="height"
  ></div>
  <p class="chart-bar__x">{{ x }}</p>
</div>
